import { render, staticRenderFns } from "./NominationSubmitForm.vue?vue&type=template&id=58f3830a"
import script from "./NominationSubmitForm.vue?vue&type=script&lang=js"
export * from "./NominationSubmitForm.vue?vue&type=script&lang=js"
import style0 from "./NominationSubmitForm.vue?vue&type=style&index=0&id=58f3830a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports